import { c as _c } from "react/compiler-runtime";
import { useState } from 'react';

// Portals that must not touch document.body during SSR (and must preserve their close
// animation/focus-restore once isOpen flips back to false) stay mounted after the first
// open. Derived from render-time state rather than an effect, matching the pattern this
// hook replaces in the bazaarvoice modal components. `document` doesn't exist during SSR, so
// a caller rendered there with isOpen already true (e.g. hydrating pre-opened state) must not
// report hasOpened=true before the client has mounted, regardless of its initial isOpen value.
const canUseDocument = (): boolean => typeof document !== 'undefined';
export function useHasOpenedOnce(isOpen) {
  const $ = _c(2);
  let t0;
  if ($[0] !== isOpen) {
    t0 = isOpen && canUseDocument();
    $[0] = isOpen;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  const [hasOpened, setHasOpened] = useState(t0);
  const [previousIsOpen, setPreviousIsOpen] = useState(isOpen);
  if (isOpen !== previousIsOpen) {
    setPreviousIsOpen(isOpen);
    if (isOpen) {
      setHasOpened(true);
    }
  }
  return hasOpened;
}
export default useHasOpenedOnce;